import { OverviewScatterChartData } from "../../../components/OverviewScatterChart/types";
import { ScoreOverview } from "../../../types/scores";

export const normalizeOverviewScatterChart = (
  scores: ScoreOverview[] | null | undefined,
): OverviewScatterChartData | null => {
  if (scores == null) return null;
  
  let sumVisibility = 0;
  
  const data = scores.map((score) => {
    sumVisibility += score.visibility;

    return {
      id: score.brand_id,
      label: score.brand_name,
      logoUrl: score.logo_url ?? "",
      visibility: score.visibility,
      sentiment: score.sentiment,
    };
  });

  return {
    averageVisibility: Math.round(sumVisibility / scores.length),
    data: data
  }
};